import React from 'react';
import styled, { x } from '@xstyled/styled-components';
import { Item, registry, RenderProps } from '../Item';
import { TWEET } from '../itemIds';
import { Flex } from '~/ui/flex/Flex';
import { Card } from '~/ui/card/Card';
import verifiedImage from './verified.svg';
import { t } from 'ttag';
import useIsDarkMode from '~/lib/themes/hooks/useIsDarkMode';

interface Props {
  pic: string;
  name: string;
  alias: string;
  width: string;
  height?: string;
}

const Verified = styled(verifiedImage)`
  width: 17px;
  height: 17px;
`;

const TweetContent = styled.div`
  font-size: 23px;
  line-height: 32px;
  padding-bottom: 15px;
  overflow-y: auto;
  color: black;
  text-align: left;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`;

export class Tweet extends Item<typeof TWEET, Props> {
  protected render({
    pic,
    name,
    alias,
    width = '90%',
    height,
    children
  }: RenderProps<Props>) {
    const isDarkMode = useIsDarkMode();

    return (
      <Flex variant="center" minWidth={0} overflow="hidden" w="100%">
        <Card
          backgroundColor="white"
          w={width}
          maxWidth="100%"
          h={height}
          minH="200px"
          minWidth={0}
          overflow="hidden"
          p={{ _: 'lg', lg: 'xl' }}
          display="flex"
          flexDirection="column"
          position="relative"
          onClick={() => true}
        >
          <x.div
            marginBottom="10px"
            position="relative"
            overflow="hidden"
            minWidth={0}
            minHeight="64px"
          >
            <x.img
              src={pic}
              h="64px"
              w="64px"
              borderRadius="50%"
              marginRight="20px"
              float="left"
              alt={t`${name} twitter avatar`}
              style={{
                backgroundColor: isDarkMode ? '#FFF' : 'transparent',
                objectFit: 'contain'
              }}
            />
            <x.div
              fontWeight="bold"
              fontSize="17px"
              fontFamily="system-ui"
              paddingTop="10px"
              display="flex"
              alignItems="center"
              flexWrap="nowrap"
              minWidth={0}
              overflow="hidden"
            >
              <x.div
                paddingRight="6px"
                color="black"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                minWidth={0}
              >
                {name}
              </x.div>
              <x.div flexShrink={0}>
                <Verified aria-label={t`Verified account`} />
              </x.div>
            </x.div>
            <x.div
              position="absolute"
              left="82px"
              top="30px"
              color="#8E8E8E"
              fontSize="17px"
              maxWidth="calc(100% - 90px)"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              dangerouslySetInnerHTML={{ __html: alias || '' }}
            />
          </x.div>
          <TweetContent tabIndex={0}>{children}</TweetContent>
        </Card>
      </Flex>
    );
  }
}

registry[TWEET] = Tweet;
